/**
 * Canonical common-environment allowlist for Product v2 browser bundles.
 *
 * Keep this module dependency-free: Vite config loads it directly in Node
 * before the application bundle exists.
 */
export const browserEnvDefinitions = Object.freeze({
	COMMON_ENV_PLATFORM_URL: "url",
	COMMON_ENV_WEBAPP_URL: "url",
	COMMON_ENV_CMS_URL: "url",
	COMMON_ENV_PRICING_URL: "url",
	COMMON_ENV_GRADER_URL: "url",
	COMMON_ENV_COURIER_URL: "url",
	COMMON_ENV_VISION_AI_URL: "nonEmpty",
	COMMON_ENV_CDN_URL: "url",
	COMMON_ENV_URL_SHORTENER: "url",
	COMMON_ENV_ENVIRONMENT: "environment",
	COMMON_ENV_POSTHOG_KEY: "nonEmpty",
	// Browser log shipping (the Axiom token is INGEST-ONLY — write-only
	// exposure, accepted as in v1; field debugging needs the logs).
	// ENV-KEYED: the kind is optional so a `develop` env may omit
	// the trio (loggers are console-only there regardless), but the schema's
	// superRefine (browser-env.ts) REQUIRES all three in every other
	// environment — shipping configs can never silently lack credentials.
	COMMON_ENV_AXIOM_TOKEN: "optionalNonEmpty",
	COMMON_ENV_AXIOM_ORG_ID: "optionalNonEmpty",
	COMMON_ENV_AXIOM_DATASET: "optionalNonEmpty",
	COMMON_ENV_POSTHOG_HOST: "url",
	COMMON_ENV_GOOGLE_API_KEY: "nonEmpty",
	COMMON_ENV_MAPBOX_TOKEN: "nonEmpty",
});

export const browserEnvKeys = Object.freeze(Object.keys(browserEnvDefinitions));
